import { ONBOARDING_PATHS } from '@/pages/onboarding/_components/onboarding-steps';
import { ShopifyConnect } from '@/pages/onboarding/connect/ShopifyConnect';
import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * What the billing modal asks of a brand that declared Shopify and has not
 * connected its store: the app install, the only way in. Once the store is
 * connected the Shopify Free plan approval takes over. A brand that does not
 * sell on Shopify after all goes back to its sales channel choice.
 */
export function ShopifyStoreConnect() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <ShopifyConnect error={null} />
      <Button variant="plain" onClick={() => navigate(ONBOARDING_PATHS.sales)}>
        {t('onboarding.billing.changeSalesChannel')}
      </Button>
    </>
  );
}
